import { render } from "./DjCapitalPoolTab.vue?vue&type=template&id=4cfc468c&scoped=true"
import script from "./DjCapitalPoolTab.vue?vue&type=script&lang=js"
export * from "./DjCapitalPoolTab.vue?vue&type=script&lang=js"

import "./DjCapitalPoolTab.vue?vue&type=style&index=0&id=4cfc468c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4cfc468c"

export default script